import React from 'react';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import FileDownload from 'js-file-download';

import { downloadTicketById } from '../../../api/profile';
import { COOKIE } from '../../../constants';

const TidalDashboardProfileTranscriptsTableWrapper = styled.div`
  overflow-x: auto;
`;

const TidalDashboardProfileTranscriptsTableTitle = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.text[1]};
  margin-bottom: 15px;
`;

const TidalDashboardProfileTranscriptsTableContainer = styled.table`
  text-align: right;
  position: relative;
  width: 100%;
  border: 0;
  border-collapse: collapse;
  border-spacing: 0;
  tr,
  td {
    padding: 10px 5px;
    border-spacing: 0;
  }
  th {
    padding: 10px 5px;
  }
  & > thead > tr > th {
    font-weight: 600;
    font-size: 14px;
    line-height: 32px;
    color: ${(props) => props.theme.colors.text[0]};
    position: sticky;
    top: 0;
    background-color: ${(props) => props.theme.colors.background};
    border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
    border-collapse: collapse;
  }

  & > thead > tr > th:nth-child(1) {
    text-align: left;
  }

  & > tbody > tr > td {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: ${(props) => props.theme.colors.text[1]};
  }

  & > tbody > tr:nth-child(even) {
    background-color: ${(props) => props.theme.colors.primary};
    td {
      border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
      border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
      border-collapse: collapse;
    }
  }

  & > tbody > tr > td:nth-child(1) {
    text-align: left;
  }

  & > tbody > tr > td:nth-child(5) {
    color: ${(props) => props.theme.colors.accent};
  }
`;

const TidalDashboardProfileTranscriptsTablePartyColumn = styled.td<{
  type: string;
}>`
  color: ${(props) =>
    props.type == 'buyer'
      ? props.theme.colors.accent
      : props.theme.colors.tags[4]} !important;
`;

interface TidalDashboardProfileTranscriptsTableProps {
  columns: string[];
  data: any[];
  label: string;
}

const TidalDashboardProfileTranscriptsTable = ({
  columns,
  data,
  label,
}: TidalDashboardProfileTranscriptsTableProps): JSX.Element => {
  const [cookies, _, removeCookie] = useCookies([COOKIE.ACCESS_TOKEN]);

  const handleDownloadTicket = async (row) => {
    try {
      const res = await downloadTicketById(row.ticket_id);
      FileDownload(res.data, `ticket-${row.ticket_id}.txt`);
    } catch (e) {}
  };
  return (
    <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <TidalDashboardProfileTranscriptsTableTitle>
        {label}
      </TidalDashboardProfileTranscriptsTableTitle>
      <TidalDashboardProfileTranscriptsTableWrapper>
        <TidalDashboardProfileTranscriptsTableContainer>
          <thead>
            <tr>
              {columns.map((column: string, key: number) => {
                return <th key={key}>{column}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {data?.map((row: any, key: number) => {
              return (
                <tr key={key}>
                  <td>{row.sale_software_name}</td>
                  <td>${row.sale_price}</td>
                  <TidalDashboardProfileTranscriptsTablePartyColumn
                    type={row.role}
                  >
                    {row.role}
                  </TidalDashboardProfileTranscriptsTablePartyColumn>
                  <td>{new Date(row.closed_at).toDateString()}</td>
                  <td
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDownloadTicket(row)}
                  >
                    Download
                  </td>
                </tr>
              );
            })}
          </tbody>
        </TidalDashboardProfileTranscriptsTableContainer>
      </TidalDashboardProfileTranscriptsTableWrapper>
    </div>
  );
};

export default TidalDashboardProfileTranscriptsTable;
